import { csts } from './constants.js';

function obtemRegrasCSTs() {
  return {
    diferimento: {
      campos: document.querySelectorAll('.campos-diferimento'),
      csts: [
        csts.diferimento
      ],
      zeraCamposAoDesabilitar: true
    },
    reducao: {
      campos: document.querySelectorAll('.campos-reducao'),
      csts: [
        csts.aliquotas.reduzida, 
        csts.reducao.deAliquotaComRedutorDeBaseDeCalculo
      ],
      habilitado: true,
      zeraCamposAoDesabilitar: true
    },
    tributados: {
      campos: document.querySelectorAll('.campos-tributados'),
      csts: [
        csts.tributacao.integral, 
        csts.tributacao.comAliquotasUniformes, 
        csts.tributacao.comAliquotasUniformesReduzidas, 
        csts.aliquotas.reduzida, 
        csts.reducao.deAliquotaComRedutorDeBaseDeCalculo, 
        csts.aliquotas.fixa, 
        csts.aliquotas.fixaProporcional, 
        csts.diferimento, 
        csts.tributacao.monofasica, 
        csts.transferenciaDeCredito, 
        csts.ajuste, 
        csts.emDeclaracaoDeRegimeEspecifico, 
        csts.exclusaoDeBaseDeCalculo]
    }
  };
}

function obtemNumeroSituacaoTributaria(situacaoTributariaSelect) {
  if (!situacaoTributariaSelect) return null;
  const selectedOption = situacaoTributariaSelect.options[situacaoTributariaSelect.selectedIndex];
  return selectedOption.text.replace(/\D/g, '');
}

function obtemCodigoClassificacaoTributaria(classificacaoTributariaSelect) {
  if (!classificacaoTributariaSelect?.value) return null;
  const selectedOption = classificacaoTributariaSelect.options[classificacaoTributariaSelect.selectedIndex];
  return selectedOption.text.match(/^\d+/)?.[0] || null;
}

async function buscaRegraClassificacaoTributaria(situacaoTributariaId, codigoClassificacao) {
  if (!situacaoTributariaId || !codigoClassificacao) return null;

  try {
    const classificacoes = await capturaConfiguracoesTributariasJSON(situacaoTributariaId);
    return classificacoes.find(item => item.codigo === codigoClassificacao) || null;
  } catch (error) {
    return null;
  }
}

function obtemConfiguracaoDiferimentoReducao(regraClassificacao) {
  if (!regraClassificacao) {
    return { diferimento: false, reducao: false };
  }

  return {
    diferimento: regraClassificacao.diferimento === true,
    reducao: regraClassificacao.reducao_de_aliquota === true
  };
}

function aplicaRegraCampo(campo, aceitaCST, regra) {
  const configDestaqueDesativado = campo.dataset.configDestaqueDesativado === 'true';

  if (regra.zeraCamposAoDesabilitar && !aceitaCST) {
    campo.value = formata_numero(0);
  }

  campo.disabled = configDestaqueDesativado || !aceitaCST;
}

function aplicaRegrasCampos(configuracao, numeroSituacaoTributaria) {
  const regrasCSTs = obtemRegrasCSTs();
  
  Object.values(regrasCSTs).forEach(regra => {
    let aceitaCST = regra.csts.includes(numeroSituacaoTributaria);

    if (regra === regrasCSTs.diferimento) {
      aceitaCST = configuracao.diferimento;
    } else if (regra === regrasCSTs.reducao) {
      aceitaCST = configuracao.reducao;
    }

    regra.campos.forEach(campo => {
      aplicaRegraCampo(campo, aceitaCST, regra);
    });
  });
}

function controlaHabilitacaoDosCampos(configuracao) {
  const situacaoTributariaSelect = document.getElementById(configuracao.situacaoTributariaId);
  const classificacaoTributariaSelect = document.getElementById(configuracao.classificacaoTributariaId);

  if (!situacaoTributariaSelect || !classificacaoTributariaSelect) return;

  let ultimaChamadaId = 0;
  async function aplicaTodasRegrasTributarias() {
    const chamadaId = ++ultimaChamadaId;
    const numeroSituacaoTributaria = obtemNumeroSituacaoTributaria(situacaoTributariaSelect);
    if (!numeroSituacaoTributaria) return;

    const situacaoTributariaId = situacaoTributariaSelect.value;
    const codigoClassificacao = obtemCodigoClassificacaoTributaria(classificacaoTributariaSelect);
    const regraClassificacao = await buscaRegraClassificacaoTributaria(situacaoTributariaId, codigoClassificacao);

    if (chamadaId !== ultimaChamadaId) {
      return;
    }

    const configuracaoDiferimentoReducao = obtemConfiguracaoDiferimentoReducao(regraClassificacao);

    aplicaRegrasCampos(configuracaoDiferimentoReducao, numeroSituacaoTributaria);
  }

  function inicializaEventListeners() {
    situacaoTributariaSelect.addEventListener('change', () => {
      aplicaTodasRegrasTributarias();
    });

    if (classificacaoTributariaSelect) {
      classificacaoTributariaSelect.addEventListener('change', () => {
        aplicaTodasRegrasTributarias();
      });
    }
  }

  aplicaTodasRegrasTributarias();
  inicializaEventListeners();
}



export { controlaHabilitacaoDosCampos };